import { ReactElement } from 'react';
import { ConfirmationModal } from './ConfirmationModal';

interface IAbandonDraftConfirmationModalProps {
  showAbandonModal: boolean;
  onAbandonConfirm: () => Promise<void>;
  onAbandonCancel: () => void;
}

export const AbandonDraftConfirmationModal = ({ showAbandonModal, onAbandonConfirm, onAbandonCancel }: IAbandonDraftConfirmationModalProps): ReactElement => {
  return (
    <ConfirmationModal
      showModal={showAbandonModal}
      onConfirm={onAbandonConfirm}
      onCancel={onAbandonCancel}
      confirmationHeader='abandon_draft'
      confirmationQuestion='abandon_draft_confirm_message'
      confirmationYes={'abandon'}
    />
  );
};
